import { EMPTY_OBJECT } from '../../../constants/common'
import { filterPermittedActionsWithDividers } from '../../../utils/massActions'

import {
  NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_ACTION,
  NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_QA_NAME,
  NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_SERVICE_REQUEST_OPTION,
} from './NewsboardPostProfileActionsWidget.constants'
import { NewsboardPostProfileActionsWidgetServiceRequestButton } from './NewsboardPostProfileActionsWidgetServiceRequestButton'

import BlockPostIcon from '../../../icons/block-post.svg'
import BlockUserIcon from '../../../icons/block-user.svg'
import DownloadIcon from '../../../icons/export.svg'
import PinIcon from '../../../icons/pin.svg'
import PinnedIcon from '../../../icons/pin-filled.svg'
import ServiceRequestIcon from '../../../icons/service-request-connect.svg'
import UnblockUserIcon from '../../../icons/unblock-user.svg'

export function isNewsboardPostProfileActionsWidgetServiceRequestOptionAddNew(
  value
) {
  return (
    value ===
    NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_SERVICE_REQUEST_OPTION.addNew
  )
}

export function getNewsboardPostProfileActionsWidgetItems({
  postData,
  serviceRequestOptions,
  t,
  onSelectServiceRequestOption,
}) {
  const permissions = postData?.permissions || EMPTY_OBJECT

  const isPinned = postData?.pinned

  const isPostBlocked = Boolean(postData?.spam)
  const isUserBlocked = permissions.can_unblock_owner

  const items = [
    {
      beforeIconProps: { Icon: isPinned ? PinnedIcon : PinIcon },
      permission: isPinned
        ? permissions.can_unpin_post
        : permissions.can_pin_post,
      qaName: NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_QA_NAME.pin,
      tooltip: t(
        isPinned
          ? 'Newsboard.UnpinPostTooltipKey'
          : 'Newsboard.PinPostTooltipKey'
      ),
      value: NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_ACTION.pin,
    },
    {
      beforeIconProps: { Icon: DownloadIcon },
      permission: postData?.file_objs?.length > 0,
      qaName: NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_QA_NAME.downloadAllFiles,
      tooltip: t('FilesGallery.DownloadAttachedFilesBtnTooltipKey'),
      value: NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_ACTION.downloadAllFiles,
    },
    {
      beforeIconProps: { Icon: BlockPostIcon },
      isActive: isPostBlocked,
      permission: permissions.can_block || permissions.can_unblock,
      qaName: NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_QA_NAME.blockPost,
      tooltip: t(
        isPostBlocked
          ? 'Newsboard.UnblockPostActionOptionKey'
          : 'Newsboard.BlockPostActionOptionKey'
      ),
      value: NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_ACTION.blockPost,
    },
    {
      beforeIconProps: {
        Icon: isUserBlocked ? UnblockUserIcon : BlockUserIcon,
      },
      permission: isUserBlocked
        ? permissions.can_unblock_owner
        : permissions.can_block_owner,
      qaName: NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_QA_NAME.blockUser,
      tooltip: t(
        isUserBlocked
          ? 'Newsboard.UnblockUserActionOptionKey'
          : 'Newsboard.BlockUserActionOptionKey'
      ),
      value: NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_ACTION.blockUser,
    },
    {
      Component: NewsboardPostProfileActionsWidgetServiceRequestButton,
      Icon: ServiceRequestIcon,
      options: serviceRequestOptions,
      permission: serviceRequestOptions.length > 0,
      qaName: NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_QA_NAME.serviceRequest,
      tooltip: t('Newsboard.AttachedRequestsLabelKey'),
      value: NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_ACTION.serviceRequest,
      onSelectOption: onSelectServiceRequestOption,
    },
  ]

  return filterPermittedActionsWithDividers(items)
}
